export const getItems = obj => Object.keys(obj).map(k => ({ value: Number(k), label: obj[k] }))
export const getRawItems = obj => Object.keys(obj).map(k => ({ value: k, label: obj[k] }))

// TODO:BROCK these enums should probably come from endpoints... don't need the front code duplicating them
// we already ran into one bug where the visa name didn't match

export const RELOCATION_PREFERENCE_TYPE_ENUM = {
  WillingToRelocate: 'Yes',
  NotWillingToRelocate: 'No',
}

export const PRACTICE_TYPE_ENUM = {
  FullTime: 'Full-Time',
  Locum: 'Locum',
  Telemedicine: 'Telemedicine',
  PartTime: 'Part-Time',
  PRN: 'PRN',
  Travel: 'Travel',
}

export const PRACTICE_TYPE_NUMERICAL_ENUM = {
  1: 'Full-Time',
  2: 'Locum',
  3: 'Telemedicine',
  4: 'Part-Time',
  5: 'PRN',
  6: 'Travel',
}

export const SHIFT_TYPE_ENUM = {
  EightDay: '8 Hours - Day',
  EightAfternoon: '8 Hours - Afternoon',
  EightOvernight: '8 Hours - Overnight',
  TwelveDay: '12 Hours - Day',
  TwelveNight: '12 Hours - Night',
  Mixed: 'Day/Night - Mixed',
}

export const SALARY_TYPE_ENUM = {
  Hourly: 'Hourly',
  Annual: 'Annual',
}

export const AREA_ENUM = {
  Urban: 'Urban',
  Rural: 'Rural',
  Suburban: 'Suburban',
}

export const ACADEMIC_ENUM = {
  Yes: 'Yes',
  Hybrid: 'Hybrid',
  No: 'No',
}

export const GLOBAL_REGION_ENUM = {
  UnitedStates: 'United States',
  Canada: 'Canada',
  Mexico: 'Mexico',
  LatinAmericaCaribbean: 'Latin America and Caribbean',
  Europe: 'Europe (EU and non-EU countries)',
  MiddleEast: 'Middle East',
  Africa: 'Africa',
  SouthAsia: 'South Asia (India, Pakistan, Bangladesh, Sri Lanka)',
  SoutheastAsia: 'Southeast Asia (Thailand, Vietnam, Philippines, Indonesia)',
  EastAsia: 'East Asia (China, Japan, South Korea, Taiwan)',
  Oceania: 'Oceania (Australia, New Zealand, Pacific Islands)',
}

// TODO: Make this dynamic from the db
export const VISA_ENUM = {
  1: 'H-1B',
  2: 'J1',
  3: 'O-1',
}

export const CANDIDATE_TYPE_ENUM = {
  1: 'Physician',
  2: 'Nurse',
  3: 'Advanced Practice Provider (NP/PA)',
  4: 'CRNA (Nurse Anesthetist)',
  5: 'Certified Nurse-Midwife',
}

export const SEARCH_STATUS_ENUM = {
  1: 'ActivelyLooking',
  2: 'PassivelyLooking',
  3: 'NotLooking',
}

export const BOARD_ELIGIBILITY_ENUM = {
  1: 'BoardCertified',
  2: 'BoardEligible',
  3: 'Neither',
}

export const USER_TUTORIAL_VIEW_ENUM = {
  CandidateJobIntro: 1,
  RecruiterJobIntro: 2,
  RecruiterCandidateIntro: 3,
  CandidateOnboardingNov2024: 4,
}

export const YEARS_EXPERIENCE_ENUM = {
  ZeroToOne: '0-1',
  TwoToFive: '2-5',
  SixToTen: '6-10',
  ElevenPlus: '11+',
}

export const LANGUAGE_ENUM = {
  English: 'English',
  'Mandarin Chinese': 'MandarinChinese',
  Hindi: 'Hindi',
  Spanish: 'Spanish',
  French: 'French',
  Arabic: 'Arabic',
  Bengali: 'Bengali',
  Russian: 'Russian',
  Portuguese: 'Portuguese',
  Urdu: 'Urdu',
  Indonesian: 'Indonesian',
  German: 'German',
  Japanese: 'Japanese',
  Swahili: 'Swahili',
  Marathi: 'Marathi',
  Telugu: 'Telugu',
  Turkish: 'Turkish',
  Tamil: 'Tamil',
  Korean: 'Korean',
  Vietnamese: 'Vietnamese',
  Italian: 'Italian',
  Hausa: 'Hausa',
  Thai: 'Thai',
  Gujarati: 'Gujarati',
  Kannada: 'Kannada',
  Persian: 'Persian',
  Polish: 'Polish',
  Ukrainian: 'Ukrainian',
  Malayalam: 'Malayalam',
  Odia: 'Odia',
  Romanian: 'Romanian',
  Burmese: 'Burmese',
  Pashto: 'Pashto',
  'Serbo-Croatian': 'SerboCroatian',
  Dutch: 'Dutch',
  Kurdish: 'Kurdish',
  Amharic: 'Amharic',
  Fulah: 'Fulah',
  Somali: 'Somali',
  Sinhala: 'Sinhala',
  Cebuano: 'Cebuano',
  Malay: 'Malay',
  Nepali: 'Nepali',
  Tagalog: 'Tagalog',
  Hungarian: 'Hungarian',
  Chichewa: 'Chichewa',
  Zulu: 'Zulu',
  Quechua: 'Quechua',
  Greek: 'Greek',
  Czech: 'Czech',
  Kinyarwanda: 'Kinyarwanda',
  Malagasy: 'Malagasy',
  Shona: 'Shona',
  Khmer: 'Khmer',
  Azerbaijani: 'Azerbaijani',
  Swedish: 'Swedish',
  Bulgarian: 'Bulgarian',
  Xhosa: 'Xhosa',
  Catalan: 'Catalan',
  Belarusian: 'Belarusian',
  'Haitian Creole': 'HaitianCreole',
  Ilocano: 'Ilocano',
  Uyghur: 'Uyghur',
  Uzbek: 'Uzbek',
  Yoruba: 'Yoruba',
  Luo: 'Luo',
  Lao: 'Lao',
  Danish: 'Danish',
  Armenian: 'Armenian',
  Slovak: 'Slovak',
  Finnish: 'Finnish',
  Tigrinya: 'Tigrinya',
  Georgian: 'Georgian',
  Basque: 'Basque',
  Breton: 'Breton',
  Icelandic: 'Icelandic',
  Irish: 'Irish',
  Welsh: 'Welsh',
  Hawaiian: 'Hawaiian',
  Maori: 'Maori',
  Samoan: 'Samoan',
  Tahitian: 'Tahitian',
  Fijian: 'Fijian',
  Tongan: 'Tongan',
  'Malagasy Sign Language': 'MalagasySignLanguage',
  'Burmese Sign Language': 'BurmeseSignLanguage',
  Mongolian: 'Mongolian',
  Wolof: 'Wolof',
  Tswana: 'Tswana',
  Afrikaans: 'Afrikaans',
  Ewe: 'Ewe',
  Twi: 'Twi',
  Igbo: 'Igbo',
  Venda: 'Venda',
  Sotho: 'Sotho',
  Bemba: 'Bemba',
  Nyanja: 'Nyanja',
  Tsonga: 'Tsonga',
  Fang: 'Fang',
  Kikuyu: 'Kikuyu',
  Other: 'Other',
}

export const PROFICIENCY_ENUM = {
  Beginner: 'Beginner',
  Intermediate: 'Intermediate',
  Proficient: 'Proficient',
  Native: 'Native',
}
